"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainEvent = void 0;
const crypto_1 = require("crypto");
const BaseLogger_1 = require("./BaseLogger");
class DomainEvent extends BaseLogger_1.BaseLogger {
    payload;
    correlationId;
    constructor(payload, correlationId) {
        super();
        this.payload = payload;
        this.correlationId = correlationId;
    }
    eventId = (0, crypto_1.randomUUID)();
    occurredAt = new Date();
    version = 1;
    eventName() {
        return this.constructor.name;
    }
    toJSON() {
        return this.getLogPayload();
    }
    getAdditionalLogContext() {
        return {
            eventCategory: 'domain',
            isAsync: true,
        };
    }
    getLogPayload() {
        return {
            correlationId: this.correlationId,
            eventId: this.eventId,
            eventName: this.eventName(),
            occurredAt: this.occurredAt.toISOString(),
            payload: this.payload,
            version: this.version,
        };
    }
    getLogType() {
        return 'domainEvent';
    }
}
exports.DomainEvent = DomainEvent;
